import * as Yup from "yup";
import { transform as applicationTransformer } from "./Application";

export const RoleValidationSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
    description: Yup.string(),
});

export const RoleObjectSchema = {
    name: "",
    description: "",
    id: "",
    application: {},
    license_id: null,
    license_uuid: "",
};

export function transform(requestData) {
    if (requestData.data) {
        return requestData.data.map((item) => transform(item));
    }

    let role = Object.assign({}, RoleObjectSchema, {
        id: parseInt(requestData.id),
        name: requestData.name,
        description: requestData.description,
        license_id: parseInt(requestData.license_id),
        license_uuid: requestData.license_uuid,
    });

    if (requestData.application) {
        let app = applicationTransformer(requestData.application);
        role = Object.assign({}, role, { application: app });
    }

    return role;
}
